import { hydrateRenderedComponents } from "@streeteasy/render-service/client";

import { AdminFooter, Footer } from "../src/features/footer";

hydrateRenderedComponents("reactFooter", {
  footer: Footer,
  adminFooter: AdminFooter
});
